/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Home_Categories_DescInputs */

const en_directory_home_categories_desc = /** @type {(inputs: Directory_Home_Categories_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A storefront-style homepage: each top-level category gets its own curated lane of picks and a direct path to more.`)
};

const zh_directory_home_categories_desc = /** @type {(inputs: Directory_Home_Categories_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用类似 App Store 的方式浏览首页：每个一级分类各有一个精选分区。`)
};

/**
* | output |
* | --- |
* | "A storefront-style homepage: each top-level category gets its own curated lane of picks and a direct path to more." |
*
* @param {Directory_Home_Categories_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_home_categories_desc = /** @type {((inputs?: Directory_Home_Categories_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Home_Categories_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_home_categories_desc(inputs)
	return zh_directory_home_categories_desc(inputs)
});
export { directory_home_categories_desc as "directory.home.categories_desc" }